export enum NameMode {
    legalName = 'legal_name',
    storeName = 'store_name',
    warehouseName = 'warehouse_name',
    none = 'none',
    custom = 'custom',
}
